import {
  TKIconFacebook,
  TKIconTwitter,
  TKIconInstagram,
  TKIconNativeEllipse,
} from "assets/images/svgs";
import React from "react";
import styled from "styled-components";
import CompanyLogo from "./CompanyLogo";
import FooterBG from "assets/images/jpgs/FooterBG.png";
import { Link } from "react-router-dom";

const Footer = () => {
  const date = new Date().getFullYear();
  const footerLinkStyle =
    "cursor-pointer leading-[28px] text-[14px] whitespace-nowrap font-normal hover:font-bold";

  return (
    <div>
      <Divider className="w-full h-[5px]"></Divider>
      <FooterContainer>
        <div className="absolute top-0 right-0">
          <div className="flex flex-col items-center gap-2">
            <div className="bg-white w-[2px] h-[60px]"></div>
            <TKIconNativeEllipse />
          </div>
        </div>
        <div className="flex flex-wrap max-[620px]:justify-center max-[400px]:items-center gap-4 mt-6 justify-between items-center px-16">
          <div className="">
            <CompanyLogo text="Be the hands of love to those in need" />
          </div>
          <div className="flex gap-2 max-[530px]:flex-col max-[530px]:justify-center max-[530px]:items-center">
            <div className="w-full flex flex-col justify-center items-center pr-3">
              <p className={`${footerLinkStyle}`}>
                <Link to="/projects">Projects</Link>
              </p>
              <p className={`${footerLinkStyle}`}>
                <Link to="/auth/donor/signup">Become A Donor</Link>
              </p>
            </div>
            <div className="w-full flex flex-col justify-center items-center pr-3">
              <p className={`${footerLinkStyle}`}>
                <Link to="/about">About Us</Link>
              </p>
              <p className={`${footerLinkStyle}`}>
                <Link to="/about">Founders</Link>
              </p>
            </div>
            <div className="w-full flex flex-col justify-center items-center pr-3">
              <p className={`${footerLinkStyle}`}>
                <Link to="/contact">Contact us</Link>
              </p>
              <p className={`${footerLinkStyle}`}>
                <Link to="/donate-money">Support</Link>
              </p>
            </div>
          </div>
        </div>
        <div className="h-[1px] w-full bg-[#EEE] opacity-10"></div>
        <div className="flex max-sm:flex-col max-sm:justify-center max-sm:items-center gap-1 pt-2 px-16 justify-between">
          <div>
            <p className="leading-[28px] text-[12px]">
              © {date} TrueKeepers, Inc.
            </p>
          </div>
          <div>
            <p className="leading-[28px] text-[12px]">
              Terms of Use | Privacy Policy
            </p>
          </div>
          <div className="flex justify-center align-middle gap-x-2">
            <TKIconTwitter className="w-[15px] hover:cursor-pointer hover:w-[17px]" />
            <TKIconFacebook className="w-[15px] hover:cursor-pointer hover:w-[17px]" />
            <TKIconInstagram className="w-[15px] hover:cursor-pointer hover:w-[17px]" />
          </div>
        </div>
      </FooterContainer>
    </div>
  );
};

export default Footer;

const FooterContainer = styled.div`
  background-image: linear-gradient(
      90deg,
      rgba(10, 38, 98, 1) 0%,
      rgba(10, 38, 98, 0.7) 308.06%
    ),
    url(${FooterBG});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 40px;
  padding: 12px 16px;
  position: relative;
  color: white;
  min-height: 250px;
`;
const Divider = styled.div`
  background: linear-gradient(270deg, #f57200 -94.44%, #f0ca18 108.89%);
`;
